export const authKeys = {
  AUTHORIZATION_KEY: 'Authorization',
  ACCESS_TOKEN_KEY: '__sm_token__',
  REFRESH_TOKEN_KEY: '__sm_refresh_token__'
};
